export default {
  'note': 'GNB.JSON, ios용 GNB 메뉴. Api를 호출할때는 apikey,credential,device,partner,pooqzone,region,drm파라메터를 클라이언트에서 추가하여 호출한다.',
  'type': 'pooq_gnbmenu',
  'version': '1.0',
  'gnblist': [
    {
      'title': '홈',
      'uicode': 'GN51',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 홈 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:click',
            'uirank:1',
            'uiparent:none',
            'uicode:GN51',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 홈 화면)',
          'url': 'apis.wavve.com/cf/supermultisections/GN51?client=40',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    },
    {
      'title': '방송',
      'uicode': 'GN2',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 방송 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:click',
            'uirank:2',
            'uiparent:none',
            'uicode:GN2',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 방송 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN2',
          'add_common_params': 'y',
          'add_credential': 'n'
        }
      ]
    },
    {
      'title': 'LIVE',
      'uicode': 'GN54',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 LIVE 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:click',
            'uirank:3',
            'uiparent:none',
            'uicode:GN54',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 LIVE 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN54',
          'add_common_params': 'y',
          'add_credential': 'n'
        }
      ]
    },
    {
      'title': '영화',
      'uicode': 'GN16',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 TV컷 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:click',
            'uirank:5',
            'uiparent:none',
            'uicode:GN16',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 TV컷 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN16',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    },
    {
      'title': '영화(SVOD)',
      'uicode': 'GN17',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 TV컷 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:click',
            'uirank:5',
            'uiparent:none',
            'uicode:GN17',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 TV컷 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN17',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    },
    {
      'title': '영화(PPV)',
      'uicode': 'GN18',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 TV컷 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:click',
            'uirank:5',
            'uiparent:none',
            'uicode:GN18',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 TV컷 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN18',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    },
    {
      'title': '해외시리즈',
      'uicode': 'GN12',
      'eventlist': [
        {
          'type': 'on-click',
          'note': '사용자 클릭시에 호출하는 기능 (클릭통계, 사용자가 TV컷 화면 메뉴를 클릭 함)',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:display',
            'uirank:12',
            'uiparent:none',
            'uicode:GN12',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 TV컷 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN12',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    },
    {
      'title': '프로야구',
      'uicode': 'GN9',
      'eventlist': [
        {
          'type': 'on-click',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:display',
            'uirank:0',
            'uiparent:FN0',
            'uicode:BN1',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 홈 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN9',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    },
    {
      'title': 'mypooq',
      'uicode': 'GN53',
      'eventlist': [
        {
          'type': 'on-click',
          'url': 'uievent3.pooq.co.kr/uievent',
          'method': 'post',
          'bodylist': [
            'type:display',
            'uirank:0',
            'uiparent:FN0',
            'uicode:BN1',
            'timestamp:$TIMESTAMP'
          ],
          'add_common_params': 'y',
          'add_credential': 'y'
        },
        {
          'type': 'on-content',
          'note': '클릭으로 인하여 하부 메뉴/콘텐츠/밴드 정보를 가져오는 기능(이 케이스에는 홈 화면)',
          'url': 'apis.pooq.co.kr/cf/supermultisections/GN53',
          'add_common_params': 'y',
          'add_credential': 'y'
        }
      ]
    }
  ]
}
